<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card>
                        <v-card-text>
                          Neues Produkt
                          <h3 class="headline">Bitte füllen Sie alle Felder aus</h3>
                          <v-text-field
                            class="pt-5"
                            autofocus
                            placeholder="Knoblauchpresse"
                            outlined
                            label="Produkt Titel"
                            v-model="product.name"
                          ></v-text-field>
                          <v-text-field
                            placeholder="PY-2NBA-003"
                            outlined
                            label="SKU"
                            v-model="product.sku"
                          ></v-text-field>
                          <v-text-field
                            placeholder="PY-2NBA-003"
                            outlined
                            label="Externe SKU"
                            v-model="product.externalSKU"
                          ></v-text-field>

                          <v-text-field
                            placeholder="WMF"
                            outlined
                            label="Marke"
                            v-model="product.brand"
                          ></v-text-field>
                          <v-text-field
                            placeholder="0"
                            outlined
                            label="Lagerbestand"
                            v-model="product.stock"
                          ></v-text-field>
                          <v-text-field
                            placeholder="0"
                            outlined
                            label="Plenty ID"
                            v-model="product.plentyId"
                          ></v-text-field>
                          <v-textarea
                            placeholder="Beschreibungstext"
                            outlined
                            label="Beschreibung"
                            v-model="product.description"
                          ></v-textarea>

                          <v-switch
                            outlined
                            :label="product.published ? 'Veröffentlicht' : 'Unveröffentlicht'"
                            color="primary"
                            v-model="product.published"
                          ></v-switch>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="6" class="pa-10">
                      <v-row class="mb-5">
                        <h2>Produktbild hochladen</h2>
                      </v-row>
                      <v-row>
                        <v-image-input
                          v-model="imageData"
                          :image-quality="1"
                          imageMinScaling="contain"
                          clearable
                          image-format="png"
                        />
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>

                <v-btn color="primary" @click="uploadImage();">Speichern</v-btn>
            
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";
import EventBus from "@/plugins/eventBus";
import AppService from "@/services/AppService";
import AssetService from "@/services/AssetService";
import ProductService from "@/services/ProductService";

export default {
  name: "dashboard",
  components: {
    Header: Header,
  },
  data: () => ({
    loading: true,
    imageData: null,
    customImageDone: false,
    customImage: null,
    step: 1,
    dpi: 1,
    product: {
      name: "",
      sku: "",
      externalSKU: "",
      brand: "",
      description: "",
      stock: 0,
      published: false,
    }
  }),
  mounted() {

  },
  methods: {
    async uploadImage() {
      try {
        this.loading = true;
        let res = (await AssetService.upload(this.imageData)).data;
        this.product.imageId = res.id;
        
        return this.save();
      } catch (err) {
        this.loading = false;
      }
    },
    async create() {
      let payload = this.app;
      payload.image = this.imageData;
      this.loading = true;
      await AppService.create(payload);
      this.loading = false;
    },

  

    async save() {
      this.loading = true;

      var appId, productId;
      try {
        EventBus.$emit("START_EXPORT_ARTBOARD");

        let productPayload = {
          name: this.product.name,
          sku: this.product.sku,
          externalSKU: this.product.externalSKU,
          brand: this.product.brand,
          plentyId: this.product.plentyId,
          description: this.product.description,
          imageId: this.product.imageId,
          stock: this.product.stock,
          published: this.product.published
        };

        appId = this.$route.params.id;

        productId = (await ProductService.create(appId, productPayload)).data;


        router.push({
          name: "Products",
          params: { id: this.$route.params.id }
        });

        this.loading = false;
      } catch (err) {
        alert(err);
        if (productId) {
          try {
            await ProductService.deleteProduct(appId, productId);
          } catch (e) {
            throw e;
          }
        }

        if (err.response && err.response.status && err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    }
  }
};
</script>
